import { useAudiencesCRUDActions } from '@mm/state/actions/AudiencesCRUDActions';
import { selectAudienceSorted } from '@mm/state/selectors/messengerAdSelectors';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

export const useAudienceNameValidation = () => {
  const audiences = useSelector(selectAudienceSorted);
  const { retrieveAll } = useAudiencesCRUDActions();
  const activeChatbotId = useSelector(activeChatbotIdSelector);

  const validateAudienceName = useCallback(
    async (name: string): Promise<boolean> => {
      if (
        audiences.some(
          a =>
            a.name.localeCompare(name, undefined, {
              sensitivity: 'accent',
            }) === 0,
        )
      ) {
        return false;
      }

      const matchingAudiences = await retrieveAll(
        activeChatbotId,
        1,
        200,
        name,
        true,
        { skipBusy: true, skipRedux: true },
      );
      return !matchingAudiences?.audiences.some(
        a =>
          a.name.localeCompare(name, undefined, {
            sensitivity: 'accent',
          }) === 0,
      );
    },
    [activeChatbotId, audiences, retrieveAll],
  );
  return { validateAudienceName };
};
